import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

// Define the types for the caixa API response
export interface CaixaTableType {
  id: number;
  terminalCodigo: number;
  razaoSocial: string;
  abertura: string;
  fechamento: string | null;
  saldo: number;
}

export interface CaixaApiResponse {
  data: CaixaTableType[];
  total: number;
  pageIndex: number;
  pageSize: number;
  isSuccess: boolean;
  message: string;
}

// Define breadcrumb for the caixa page
export const caixaBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Operacional",
    url: "#!",
  },
  {
    label: "Caixas",
    active: true,
  },
];
